const positionFrostedItems = frostedItems => {
    const parent = frostedItems.closest(".CallToAction");

    let height = parent.outerHeight();
    let parentOffsetTop = parent[0].getBoundingClientRect().top;

    frostedItems.each(function() {
        let inner = this.querySelector(".CallToAction--frosted-inner");
        let boundingBox = this.getBoundingClientRect();

        inner.style.height = height + "px";
        inner.style.left = -boundingBox.left + "px";
        inner.style.top = -(boundingBox.top - parentOffsetTop) + "px";
    });
};

const frostedItems = $(
    ".CallToAction-buttonGroup-button .CallToAction--frosted"
);

if (frostedItems.length) {
    setTimeout(function() {
        $(window).resize(function() {
            positionFrostedItems(frostedItems);
        });

        positionFrostedItems(frostedItems);
    }, 500);
}



// WEBPACK FOOTER //
// ../modules/Calltoaction/assets/scripts/main.js